import React from 'react';

import DropdownMenu, { DropdownItem } from '@atlaskit/dropdown-menu';

import { TestType } from '@qality/common-model';
import { useTestTypesContext } from '@qality/common-pages';

import TestTypePopupSelectOption from '../../atoms/TestTypePopupSelectOption/TestTypePopupSelectOption';

type Props = {
  handleTestTypeSelection: (testType: TestType) => void;
};

export default function TestTypeDropdown({
  handleTestTypeSelection,
}: Props): JSX.Element {
  const { testTypes } = useTestTypesContext();
  const getTestTypeOptions = () => {
    return testTypes.map((testType) => (
      <DropdownItem
        key={`test-type-option-${testType.id}`}
        onClick={() => handleTestTypeSelection(testType)}
      >
        <TestTypePopupSelectOption testType={testType} />
      </DropdownItem>
    ));
  };

  return (
    <DropdownMenu trigger='Choose test type'>
      {getTestTypeOptions()}
    </DropdownMenu>
  );
}
